import React from 'react';
import { Container } from 'reactstrap';

const DataProcessingAgreement = () => {
  return (
    <Container className="py-5">
      <div className="legal-document">
        <h1 className="mb-4">Data Processing Agreement</h1>
        
        <section className="mb-4">
          <h2>1. Introduction</h2>
          <p>This Data Processing Agreement ("DPA") forms part of our commitment to comply with the Protection of Personal Information Act, 2013 ("POPIA") and other applicable data protection laws. This agreement outlines how we process personal information in the context of our SME and Supplier ESG Readiness Tool.</p>
        </section>

        <section className="mb-4">
          <h2>2. Definitions</h2>
          <ul>
            <li>"Personal Information" means information relating to an identifiable, living, natural person, and where it is applicable, an identifiable, existing juristic person</li>
            <li>"Processing" means any operation or activity, whether or not by automatic means, concerning personal information</li>
            <li>"Data Subject" means the person to whom personal information relates</li>
            <li>"Operator" means a person who processes personal information for a responsible party in terms of a contract or mandate</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>3. Processing of Personal Information</h2>
          <h3>3.1 Types of Personal Information Processed</h3>
          <ul>
            <li>Company registration details</li>
            <li>Contact information of authorized representatives</li>
            <li>Assessment responses and supporting documentation</li>
            <li>User account information</li>
            <li>Technical data and usage information</li>
          </ul>

          <h3>3.2 Purpose of Processing</h3>
          <ul>
            <li>Providing and improving the SME and Supplier ESG Readiness Tool</li>
            <li>Processing assessment submissions</li>
            <li>Generating assessment reports</li>
            <li>Communicating with users</li>
            <li>Ensuring security and preventing fraud</li>
            <li>Complying with legal obligations</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>4. Security Measures</h2>
          <p>We implement appropriate technical and organizational measures to ensure a level of security appropriate to the risk, including:</p>
          <ul>
            <li>Encryption of data in transit and at rest</li>
            <li>Regular security assessments and updates</li>
            <li>Access controls and authentication mechanisms</li>
            <li>Regular backup procedures</li>
            <li>Employee training on data protection</li>
            <li>Incident response procedures</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>5. Data Subject Rights</h2>
          <p>Under POPIA, data subjects have the following rights:</p>
          <ul>
            <li>Right to access their personal information</li>
            <li>Right to request correction of personal information</li>
            <li>Right to request deletion of personal information</li>
            <li>Right to object to processing of personal information</li>
            <li>Right to request restriction of processing</li>
            <li>Right to data portability</li>
            <li>Right to withdraw consent</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>6. Data Retention</h2>
          <p>We retain personal information only for as long as necessary to fulfill the purposes for which it was collected, including:</p>
          <ul>
            <li>Assessment data: Retained for 7 years</li>
            <li>User account information: Retained while account is active</li>
            <li>Technical logs: Retained for 12 months</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>7. Third-Party Processors</h2>
          <p>We may engage third-party processors to assist in providing our services. These processors are contractually bound to:</p>
          <ul>
            <li>Process personal information only on our instructions</li>
            <li>Implement appropriate security measures</li>
            <li>Maintain confidentiality</li>
            <li>Assist us in fulfilling our data protection obligations</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>8. International Transfers</h2>
          <p>If personal information is transferred outside South Africa, we ensure appropriate safeguards are in place to protect the data, including:</p>
          <ul>
            <li>Standard contractual clauses</li>
            <li>Binding corporate rules</li>
            <li>Other legally recognized transfer mechanisms</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>9. Changes to this Agreement</h2>
          <p>We may update this DPA from time to time to reflect changes in our practices or legal requirements. We will notify you of any material changes through the platform or via email.</p>
        </section>

        <section className="mb-4">
          <h2>10. Contact Information</h2>
          <p>For any questions about this DPA or our data processing practices, please contact us at:</p>
          <ul>
            <li>Email: info@globalcompactsa.org.za</li>
            <li>Phone: +27 11 771 41 42</li>
            <li>Address: 26 Melville Road, Johannesburg, South Africa</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>11. Governing Law</h2>
          <p>This DPA shall be governed by and construed in accordance with the laws of South Africa, and any disputes shall be subject to the exclusive jurisdiction of the courts of South Africa.</p>
        </section>
      </div>
    </Container>
  );
};

export default DataProcessingAgreement; 